import React from "react";

const MessageA3D = (props) => {
  return <div className="disclaimer-msg">{props?.item?.text}</div>;
};

export default MessageA3D;
